export const PAYROLL_FILTERS = {
  PAYROLL_FILTERS_SET_SELECTED: "PAYROLL_FILTERS_SET_SELECTED",
  PAYROLL_FILTERS_CLEAR_SELECTED: "PAYROLL_FILTERS_CLEAR_SELECTED",
};
